export const heroStats = [
  { label: '在播剧集', value: '3500+' },
  { label: '每日更新', value: '200+集' },
  { label: '高清画质', value: '1080P' },
];

export const aboutData = {
  title: '关于爱丫爱丫',
  description: '爱丫爱丫影院是一个专注电视剧大全全集免费在线观看的平台，覆盖最新国产剧、韩剧全集等热门资源。我们以高清流畅不缓冲为核心体验，所有剧集极速秒开，让每一位剧迷都能轻松追剧。平台每日更新超过200集内容，涵盖都市情感、古装传奇、悬疑探案、青春偶像等多元题材，致力打造最便捷的免费高清影视入口。',
  imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20theater%20setup%20with%20large%20screen%20displaying%20cinematic%20content%2C%20soft%20ambient%20lighting%2C%20comfortable%20seating%2C%20modern%20minimalist%20interior%2C%20warm%20golden%20and%20cream%20tones%2C%20artistic%20composition%2C%20high%20detail%20editorial%20photography%2C%20elegant%20and%20inviting%20atmosphere&width=800&height=500&seq=about-cinema-01&orientation=landscape',
};

export const rankingData = [
  { rank: 1, title: '星光之城', category: '国产剧', score: '9.6', tag: '热播中', description: '都市情感大戏，当红演员倾情演绎' },
  { rank: 2, title: '月落长安', category: '古装剧', score: '9.4', tag: '新剧上线', description: '盛世长安风云再起，权谋与情感交织' },
  { rank: 3, title: '暗夜追光', category: '悬疑剧', score: '9.3', tag: '高分必看', description: '层层反转的悬疑烧脑之旅' },
  { rank: 4, title: '她的季节', category: '韩剧', score: '9.2', tag: '催泪推荐', description: '治愈系韩剧，温暖你整个季节' },
  { rank: 5, title: '山海传说', category: '奇幻剧', score: '9.0', tag: '特效大作', description: '东方奇幻史诗巨制震撼上线' },
  { rank: 6, title: '逆流时光', category: '韩剧', score: '8.9', tag: '穿越经典', description: '穿越时空的爱情，每一帧都是心动' },
];

export const cardsData = [
  { title: '长安十二时辰', category: '国产剧 · 古装悬疑', description: '大唐盛世下的惊天阴谋，一昼夜的生死追逐。', imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20warm%20lantern%20light%2C%20traditional%20architecture%20details%2C%20dramatic%20shadows%2C%20historical%20atmosphere%2C%20cinematic%20lighting%2C%20rich%20warm%20amber%20and%20crimson%20tones%2C%20elegant%20composition&width=600&height=400&seq=card-drama-01&orientation=landscape' },
  { title: '来自星星的你', category: '韩剧 · 浪漫爱情', description: '外星人与顶级女星的跨星际浪漫奇缘。', imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20night%20cityscape%20with%20twinkling%20stars%2C%20soft%20dreamy%20bokeh%20lights%2C%20couple%20silhouette%20on%20rooftop%2C%20warm%20golden%20and%20deep%20blue%20tones%2C%20cinematic%20romantic%20atmosphere%2C%20editorial%20photography&width=600&height=400&seq=card-drama-02&orientation=landscape' },
  { title: '隐秘的角落', category: '国产剧 · 犯罪悬疑', description: '三个孩子的夏日冒险，揭开成人世界的黑暗。', imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20coastal%20town%20with%20old%20buildings%2C%20narrow%20alleyways%2C%20warm%20sunlight%20casting%20long%20shadows%2C%20slightly%20mysterious%20atmosphere%2C%20nostalgic%20vintage%20feel%2C%20cinematic%20composition%2C%20warm%20earthy%20tones&width=600&height=400&seq=card-drama-03&orientation=landscape' },
  { title: '请回答1988', category: '韩剧 · 温情治愈', description: '双门洞的故事，关于青春、家人与初恋。', imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%201980s%20Korean%20neighborhood%20alley%2C%20warm%20evening%20glow%2C%20traditional%20houses%2C%20children%20playing%2C%20retro%20atmosphere%2C%20golden%20hour%20lighting%2C%20heartwarming%20and%20cozy%20scene%2C%20cinematic%20look&width=600&height=400&seq=card-drama-04&orientation=landscape' },
  { title: '琅琊榜', category: '国产剧 · 权谋传奇', description: '一卷风云琅琊榜，囊尽天下奇英才。', imageUrl: 'https://readdy.ai/api/search-image?query=Majestic%20ancient%20Chinese%20mountain%20landscape%20with%20mist%2C%20traditional%20pavilions%2C%20pine%20trees%2C%20ink%20wash%20painting%20aesthetic%2C%20ethereal%20atmosphere%2C%20soft%20muted%20tones%2C%20elegant%20and%20refined%20composition&width=600&height=400&seq=card-drama-05&orientation=landscape' },
  { title: '黑暗荣耀', category: '韩剧 · 复仇大戏', description: '年少伤痛化为复仇烈焰，一局精心布下的棋。', imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20dark%20interior%20with%20dramatic%20spotlight%2C%20chess%20board%20on%20marble%20table%2C%20rich%20deep%20contrast%2C%20luxurious%20minimalist%20aesthetic%2C%20mysterious%20and%20sophisticated%20atmosphere%2C%20cinematic%20noir%20lighting&width=600&height=400&seq=card-drama-06&orientation=landscape' },
  { title: '甄嬛传', category: '国产剧 · 宫斗经典', description: '一朝入宫深似海，步步惊心话宫闱。', imageUrl: 'https://readdy.ai/api/search-image?query=Imperial%20Chinese%20palace%20garden%20with%20blooming%20peonies%2C%20traditional%20red%20pillars%20and%20golden%20roofs%2C%20elegant%20female%20silhouette%20in%20traditional%20hanfu%2C%20warm%20sunset%20light%2C%20rich%20crimson%20and%20gold%20tones%2C%20cinematic%20composition&width=600&height=400&seq=card-drama-07&orientation=landscape' },
];

export const updatesData = [
  { time: '今日 20:00', title: '《星光之城》第28集更新上线', tag: '最新' },
  { time: '今日 18:30', title: '《月落长安》大结局超前点播开启', tag: '热门' },
  { time: '今日 16:00', title: '《她的季节》第14集韩语中字发布', tag: '字幕' },
  { time: '今日 12:00', title: '新剧《暗夜追光》全24集一次性上线', tag: '上新' },
  { time: '昨日 22:00', title: '《山海传说》第32集特效升级版更新', tag: '高清' },
  { time: '昨日 19:00', title: '《逆流时光》韩国收视冠军登录本站', tag: '引进' },
  { time: '昨日 15:00', title: '暑期追剧季专题页面上线，热门剧集一网打尽', tag: '活动' },
  { time: '昨日 10:00', title: '《长安十二时辰》导演剪辑版独家上线', tag: '独家' },
  { time: '7月30日', title: '平台服务器全面升级，播放体验再提升', tag: '公告' },
];

export const contactData = {
  title: '联系我们',
  description: '欢迎剧迷朋友们通过以下方式与我们取得联系。无论是剧集推荐、问题反馈还是合作洽谈，爱丫爱丫影院期待你的声音。',
  email: 'contact@aiyaaiya.tv',
  wechat: 'aiyaaiya_tv',
  qq: '1234567890',
};

export const topicsData = [
  { name: '星光之城剧情讨论', count: '128万', hot: true },
  { name: '月落长安大结局', count: '96万', hot: true },
  { name: '暑期档国产剧推荐', count: '85万', hot: true },
  { name: '暗夜追光凶手是谁', count: '73万', hot: false },
  { name: '韩剧入坑必看清单', count: '68万', hot: false },
  { name: '古装剧服化道盘点', count: '55万', hot: false },
  { name: '2026最期待新剧', count: '49万', hot: false },
  { name: '悬疑剧天花板', count: '42万', hot: false },
  { name: '治愈系电视剧安利', count: '38万', hot: false },
  { name: '经典老剧重温计划', count: '31万', hot: false },
];

export const featuresData = [
  {
    icon: 'ri-4k-line',
    title: '高清流畅不缓冲',
    description: '全站剧集支持1080P高清画质，智能CDN加速确保播放流畅无卡顿，无论何时何地都能享受沉浸式观影体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速秒开看剧',
    description: '业界领先的播放引擎技术，点击即播无需等待。片源预加载与智能缓存机制，让追剧零延迟、零等待。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '免费高清影视',
    description: '国产剧全集、韩剧全集全覆盖，全部内容免费在线观看。无需注册会员，打开网页就能畅享海量正版剧集资源。',
  },
];

export const appData = {
  title: '移动追剧',
  description: '爱丫爱丫影院移动端适配完美，手机浏览器直接访问即可享受与大屏一致的流畅观影体验。支持画中画播放、离线缓存与投屏功能，随时随地追剧不间断。',
  imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20cinematic%20content%20on%20screen%2C%20floating%20on%20warm%20gradient%20background%2C%20minimalist%20product%20photography%2C%20soft%20golden%20and%20cream%20lighting%2C%20elegant%20premium%20feel%2C%20clean%20composition%2C%20high%20detail&width=600&height=700&seq=app-mobile-01&orientation=portrait',
};

export const indexData = [
  { title: '国产剧全集', count: '1200+部', icon: 'ri-film-line' },
  { title: '韩剧全集', count: '800+部', icon: 'ri-heart-line' },
  { title: '古装传奇', count: '450+部', icon: 'ri-ancient-gate-line' },
  { title: '都市情感', count: '520+部', icon: 'ri-building-line' },
  { title: '悬疑探案', count: '380+部', icon: 'ri-search-eye-line' },
  { title: '青春偶像', count: '290+部', icon: 'ri-star-line' },
  { title: '奇幻科幻', count: '210+部', icon: 'ri-rocket-line' },
  { title: '高分必看', count: '160+部', icon: 'ri-trophy-line' },
  { title: '最新上线', count: '每日更新', icon: 'ri-timer-flash-line' },
];

export const carouselData = [
  {
    title: '星光之城',
    category: '国产剧 · 都市情感 · 热播中',
    description: '当红实力演员倾情演绎，一座城市的星光与梦想。职场、爱情、友情三重奏，每一集都引发全网热议。豆瓣开分9.6，年度现象级都市大剧。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20night%20with%20twinkling%20city%20lights%2C%20warm%20golden%20window%20lights%20in%20skyscrapers%2C%20cinematic%20aerial%20view%2C%20romantic%20urban%20atmosphere%2C%20soft%20dreamy%20bokeh%2C%20elegant%20noir%20aesthetic%2C%20high%20detail&width=700&height=450&seq=carousel-show-01&orientation=landscape' },
  {
    title: '月落长安',
    category: '国产剧 · 古装传奇 · 新剧上线',
    description: '盛世长安风云再起，权谋与情感交织的史诗级古装大制作。顶级服化道团队打造视觉盛宴，豆瓣9.4分古装新标杆。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20city%20at%20dusk%2C%20traditional%20palace%20rooftops%20with%20golden%20tiles%2C%20warm%20sunset%20glow%2C%20misty%20atmosphere%2C%20grand%20epic%20scale%2C%20cinematic%20lighting%2C%20rich%20amber%20and%20crimson%20tones&width=700&height=450&seq=carousel-show-02&orientation=landscape' },
  {
    title: '暗夜追光',
    category: '国产剧 · 悬疑探案 · 高分必看',
    description: '一桩尘封旧案、三个关键证人、七十二小时极限破案。剧情层层反转，每个细节都暗藏伏笔。悬疑烧脑巅峰之作，全网推理热潮不断。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20rainy%20alley%20with%20single%20streetlamp%20glow%2C%20wet%20cobblestone%20reflections%2C%20mysterious%20noir%20atmosphere%2C%20deep%20shadows%2C%20cinematic%20thriller%20aesthetic%2C%20moody%20contrast%2C%20elegant%20composition&width=700&height=450&seq=carousel-show-03&orientation=landscape' },
  {
    title: '她的季节',
    category: '韩剧 · 治愈温情 · 催泪推荐',
    description: '四个季节、四个故事、四种人生。韩国顶级编剧年度力作，用最细腻的镜头语言讲述平凡生活中的不凡感动。本季最治愈的韩剧没有之一。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20cherry%20blossom%20path%20in%20spring%20park%2C%20soft%20pink%20petals%20falling%2C%20warm%20sunlight%20through%20trees%2C%20gentle%20romantic%20atmosphere%2C%20Korean%20drama%20aesthetic%2C%20dreamy%20and%20healing%20vibe%2C%20cinematic%20photography&width=700&height=450&seq=carousel-show-04&orientation=landscape' },
];

export const faqData = [
  {
    question: '爱丫爱丫影院的电视剧真的全部免费吗？',
    answer: '是的，爱丫爱丫影院所有剧集完全免费在线观看，无需注册会员，无需付费订阅。我们通过合法授权与合作模式为广大剧迷提供最新的国产剧、韩剧全集等高清影视内容。',
  },
  {
    question: '播放视频为什么会卡顿？如何解决？',
    answer: '播放卡顿通常与您的网络环境有关。建议：检查WiFi或移动网络信号强度、关闭占用带宽的后台应用、尝试切换清晰度（如从1080P降至720P）、刷新页面或更换浏览器。爱丫爱丫影院已部署智能CDN加速，绝大多数用户均可实现流畅播放。',
  },
  {
    question: '剧集更新频率是怎样的？',
    answer: '平台每日更新超过200集内容，国产剧热播剧集一般在电视台播出后2小时内上线；韩剧通常在韩国播出后6-8小时内提供中文字幕版本。所有更新动态可在首页「追剧快讯」模块实时查看。',
  },
  {
    question: '支持哪些设备观看？可以投屏吗？',
    answer: '爱丫爱丫影院完美适配电脑、平板和手机浏览器，无需下载任何APP。同时支持AirPlay和DLNA投屏功能，您可以将剧集投射到智能电视或投影仪上享受大屏观影。',
  },
  {
    question: '如何推荐我想看的剧集？',
    answer: '欢迎通过「联系我们」模块提供的邮箱或微信与我们沟通。我们会定期收集剧迷的推荐和反馈，根据大家的需求引进更多优质电视剧资源。',
  },
];

export const mediaData = [
  {
    title: '《星光之城》幕后特辑',
    description: '主创团队分享拍摄趣事与角色塑造心得',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20production%20set%20with%20cameras%20and%20lighting%20equipment%2C%20director%20monitor%20screen%2C%20warm%20studio%20lighting%2C%20behind%20the%20scenes%20atmosphere%2C%20professional%20cinematography%2C%20cinematic%20look%2C%20golden%20and%20cream%20tones&width=600&height=380&seq=media-bts-01&orientation=landscape' },
  {
    title: '《月落长安》服化道揭秘',
    description: '还原盛世唐朝的服装设计与场景搭建全记录',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20costume%20display%20with%20intricate%20embroidery%2C%20ancient%20accessories%2C%20warm%20museum%20lighting%2C%20historical%20artifacts%2C%20elegant%20textile%20details%2C%20rich%20crimson%20and%20gold%20tones%2C%20cinematic%20presentation&width=600&height=380&seq=media-costume-02&orientation=landscape' },
  {
    title: '《暗夜追光》导演专访',
    description: '导演深度解析悬疑叙事手法与隐藏彩蛋',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20film%20director%20interview%20setup%2C%20warm%20studio%20environment%2C%20cinema%20camera%20in%20background%2C%20soft%20key%20light%2C%20creative%20atmosphere%2C%20documentary%20style%2C%20elegant%20composition%2C%20warm%20earthy%20tones&width=600&height=380&seq=media-interview-03&orientation=landscape' },
  {
    title: '《她的季节》OST全收录',
    description: '韩国顶级音乐人打造的治愈系原声大碟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20record%20player%20on%20wooden%20table%2C%20warm%20sunlight%20streaming%20through%20window%2C%20cozy%20room%20with%20plants%2C%20music%20sheets%20scattered%2C%20nostalgic%20aesthetic%2C%20soft%20golden%20hour%20light%2C%20healing%20and%20peaceful%20atmosphere&width=600&height=380&seq=media-ost-04&orientation=landscape' },
];

export const commentsData = [
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20person%20avatar%20portrait%2C%20warm%20friendly%20smile%2C%20simple%20cream%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style%2C%20clean%20minimalist%20look&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    time: '2小时前',
    content: '爱丫爱丫真的是我每天必刷的网站！更新速度太快了，昨晚播的《星光之城》今天上午就有高清版，画质清晰得不得了，一点不缓冲。已经安利给身边所有追剧的朋友了！',
  },
  {
    name: '韩剧重度患者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20avatar%20portrait%2C%20gentle%20smile%2C%20simple%20cream%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style%2C%20clean%20minimalist%20aesthetic&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    time: '5小时前',
    content: '韩剧资源太全了！《她的季节》中文翻译质量很高，而且完全没有广告弹窗，观影体验一级棒。秒开看剧这个真的没吹牛，点开就能看，比好多付费平台还快。',
  },
  {
    name: '悬疑控晚期',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20avatar%20portrait%2C%20thoughtful%20expression%2C%20simple%20cream%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style%2C%20clean%20minimalist%20look&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    time: '1天前',
    content: '《暗夜追光》全程高能！每集结尾都留悬念，根本停不下来。爱丫爱丫影院1080P清晰度看悬疑片细节特别过瘾，演员的微表情都看得一清二楚。国产剧全集这里最全了！',
  },
];

export const footerLinks = {
  about: [
    { label: '平台介绍', href: '#about' },
    { label: '追剧快讯', href: '#updates' },
    { label: '联系我们', href: '#contact' },
    { label: '常见问题', href: '#faq' },
  ],
  content: [
    { label: '精选好剧', href: '#cards' },
    { label: '热播风云榜', href: '#ranking' },
    { label: '重磅推荐', href: '#carousel' },
    { label: '热门话题', href: '#topics' },
  ],
  features: [
    { label: '平台亮点', href: '#features' },
    { label: '移动追剧', href: '#app' },
    { label: '剧集索引', href: '#index' },
    { label: '精彩花絮', href: '#media' },
  ],
};